import { combineReducers } from 'redux'
import progLangListReducer from './progLangListReducer'
import languageListReducer from './languageListReducer'
import sideNavReducer from './sideNavReducer'

export default combineReducers({
    progLangList: progLangListReducer,
    languageList: languageListReducer,
    sideNav: sideNavReducer,
})